import React from 'react';

import {maxLengthInputs} from '../../../../util/uiconstants';
import {PROJECT_NAME} from '../utils/constants';

import Input from '../../../CoreWrappers/Input';
import StyledInputWithHeader from '../StyledInputWithHeader';

const ProjectName = ({values, errors, handleChange, handleSubmit, handleReset, isFormValid, labels, renderHeader}) => {
	const id = PROJECT_NAME;

	const props = {
		id,
		value: values[id],
		onChange: (e) => handleChange(id, e.target.value),
		label: labels[id],
		maxLength: maxLengthInputs.projectName
	};

	if (errors[id]) props.errorMessage = errors[id]?.message;

	return (
		<StyledInputWithHeader>
			{renderHeader(labels[id])}
			<Input {...props} />
		</StyledInputWithHeader>
	);
};

export default ProjectName;
